class agoraElectron {
  constructor() {
	if ( window.AgoraRtcEngine == null ) { return false; }
	
    this.mainAgora = new window.AgoraRtcEngine();
    this.callData = {};
    this.psBlockerId = null;
  }

  connect = (agoraAppId) => {
	if ( this.mainAgora == null ) { 
		this.mainAgora = new window.AgoraRtcEngine();
	}
	
    var agoraConnect = this.mainAgora.initialize(agoraAppId);
    if (agoraConnect) {
      console.log("unable to initialize electron services, code -> " + agoraConnect + " appId: " + agoraAppId);
      return false;
    }
    return true;
  };

  getVideoDevices = () => {
    return JSON.stringify(this.mainAgora.getVideoDevices());
  };

  getAudioRecordingDevices = () => {
    return this.mainAgora.getAudioRecordingDevices();
  };

  getAudioPlaybackDevices = () => {
    return this.mainAgora.getAudioPlaybackDevices();
  };

  //stream devices
  setAudioRecordingDevice = (deviceId) => {
    var device = Object.values(deviceId)[0][0];
    return this.mainAgora.setAudioRecordingDevice(device);
  };

  setVideoDevice = (deviceId) => {
    var device = Object.values(deviceId)[0][0];
    return this.mainAgora.setVideoDevice(device);
  };

  setAudioPlaybackDevice = (deviceId) => {
    var device = Object.values(deviceId)[0][0];
    return this.mainAgora.setAudioPlaybackDevice(device);
  };

  getCurrentVideoDeviceOnetoOne = () => {
    return this.mainAgora.getCurrentVideoDevice();
  };

  getCurrentAudioRecordingDevice = () => {
    return this.mainAgora.getCurrentAudioRecordingDevice();
  };

  getCurrentAudioPlaybackDevice = () => {
    return this.mainAgora.getCurrentAudioPlaybackDevice();
  };

  showMyCamera = (elementId) => {
    this.mainAgora.startPreview();
    this.mainAgora.setupLocalVideo(document.querySelector(elementId));
  };

  setStreamData = (streamData) => {
    this.callData = JSON.parse(streamData.split("@~~@")[0]);

    if (
      this.callData &&
      this.callData.responseData &&
      this.callData.responseData.appId &&
      this.connect(this.callData.responseData.appId)
    ) {
      // App connected
      document.querySelector("#agora_ondemand_local").innerHTML = "";

      this.mainAgora.on("error", (error) => {
        console.log(error);
      });

      this.mainAgora.on("localVideoStateChanged", (localVideoState, error) => {
        if (localVideoState === 1 && document.querySelector("#agora_camera_disabled") === null) {
          document.querySelector("#agora_local_stream").innerHTML = "";
          this.showMyCamera("#agora_local_stream");
        }
        if (localVideoState === 2 && document.querySelector("#agora_camera_disabled_permission")) {
          document.querySelector("#agora_local_stream").innerHTML = "";
          this.showMyCamera("#agora_local_stream");
        } else if (localVideoState === 3) {
          document.querySelector("#agora_local_stream").innerHTML = '<div id="agora_camera_disabled_permission"></div>';
        }
      });

      this.mainAgora.on("rtcStats", (stats) => {
        window.flutter_users_number(stats.users);
        if (stats.users === 1) {
          document.querySelector("#agora_other_stream").innerHTML = "";
        }
      });

      var joinError = this.mainAgora.joinChannel(
        this.callData.responseData.sessionToken,
        this.callData.responseData.rtcChannelId,
        null,
        this.callData.responseData.currentUser
      );
      if (!joinError) {
        // Channel joined successfully
        if ( !!window["powerSaveBlocker"] ) { this.psBlockerId = window["powerSaveBlocker"].start('prevent-display-sleep'); }
        this.mainAgora.on("userJoined", (uid) => {
          this.mainAgora.subscribe(uid, document.querySelector("#agora_other_stream"));

          setTimeout(() => {
            const parent = document.getElementById("agora_other_stream");
            var child = parent.childNodes[0];
            var canvas = child.childNodes[0];
            if (canvas && canvas.height === 0) {
              document.querySelector("#agora_other_stream").innerHTML = '<div id="agora_user_left_call"></div>';
            }
          }, 2000);

          this.mainAgora.on("remoteVideoStateChanged", (uid, state, reason, elapsed) => {
            this.mainAgora.subscribe(uid, document.querySelector("#agora_other_stream"));
            if (state === 2) {
              document.querySelector("#agora_other_stream").innerHTML = "";
              this.mainAgora.subscribe(uid, document.querySelector("#agora_other_stream"));
            }
          });

          /* this.mainAgora.on("remoteVideoStateChanged", (uid, state, reason, elapsed) => {
            this.mainAgora.subscribe(uid, document.querySelector("#agora_other_stream"));
            console.log(reason);
            console.log(state);
            if (state === 2) {
              //document.querySelector("#agora_other_stream").innerHTML = "";
              //document.querySelector("#agora_user_left_call").className = "hide_cross_camera";
              //this.mainAgora.subscribe(uid, document.querySelector("#agora_other_stream"));
            } else if (state === 3) {
              document.querySelector("#agora_other_stream").innerHTML = '<div id="agora_user_left_call"></div>';
            }
          }); */

          this.mainAgora.on("userMuteVideo", (uid, muted) => {
            if (muted === true) {
              document.querySelector("#agora_other_stream").innerHTML = '<div id="agora_user_left_call"></div>';
            } else if (muted === false && document.querySelector("#agora_user_left_call")) {
              document.querySelector("#agora_other_stream").innerHTML = "";
              this.mainAgora.subscribe(uid, document.querySelector("#agora_other_stream"));
            }
          });

          window.flutter_hostConnectionState(3);
        });

        this.listenEvents();
      }
    }
  };

  streamCallback = (streamData) => {
    var callback = Object.values(streamData)[0];
    if (callback[0] == "close") {
      console.log("in leave #1");

      if ( this.psBlockerId != null ) { window["powerSaveBlocker"].stop(this.psBlockerId); }
      this.psBlockerId = null;

      this.mainAgora.leaveChannel();
      this.mainAgora.stopPreview();
      this.mainAgora.release();
	  this.mainAgora = null;
	  
      document.querySelector("#agora_local_stream").innerHTML = "";
      document.querySelector("#agora_other_stream").innerHTML = "";
    }
    if (callback[0] == "muteMic") {
      if (callback[1] == 1) {
        this.mainAgora.muteLocalAudioStream(true);
      } else if (callback[1] == 0) {
        this.mainAgora.muteLocalAudioStream(false);
      }
    }

    if (callback[0] == "dsblCam") {
      if (callback[1] == 1) {
        if (document.querySelector("#agora_camera_disabled_permission") === null) {
          this.mainAgora.muteLocalVideoStream(true);
          document.querySelector("#agora_local_stream").innerHTML = '<div id="agora_camera_disabled"></div>';
        }
      } else if (callback[1] == 0) {
        if (document.querySelector("#agora_camera_disabled")) {
          this.mainAgora.muteLocalVideoStream(false);
          document.querySelector("#agora_local_stream").innerHTML = "";
          this.showMyCamera("#agora_local_stream");
        }
      }
    }

    if (callback[0] == "dsblSpeaker") {
      if (callback[1] == 1) {
        this.mainAgora.muteAllRemoteAudioStreams(true);
      } else if (callback[1] == 0) {
        this.mainAgora.muteAllRemoteAudioStreams(false);
      }
    }

    if (callback[0] == "stopMicTsting") {
      if (callback[1] == 1) {
        this.stopMicTesting = true;
      } else if (callback[1] == 2) {
        this.stopMicTesting = false;
      }
    }
  };

  listenNative = () => {
    window.startAgoraStream = this.setStreamData;
    window.streamCallback = this.streamCallback;
    window.getVideoDevices = this.getVideoDevices;
    window.getAudioRecordingDevices = this.getAudioRecordingDevices;
    window.getAudioPlaybackDevices = this.getAudioPlaybackDevices;
    window.setAudioRecordingDevice = this.setAudioRecordingDevice;
    window.setVideoDeviceAgora = this.setVideoDevice;
    window.setAudioPlaybackDevice = this.setAudioPlaybackDevice;
    window.getCurrentVideoDeviceOnetoOne = this.getCurrentVideoDeviceOnetoOne;
    window.getCurrentAudioRecordingDevice = this.getCurrentAudioRecordingDevice;
    window.getCurrentAudioPlaybackDevice = this.getCurrentAudioPlaybackDevice;
    window.microphoneTest = this.microphoneTest;
    window.speakerTest = this.speakerTest;
    window.visualizerHide = this.visualizerHide;
    window.stopSpeakerTestOneToOne = this.stopSpeakerTestOneToOne;
    window.stopMicAudioTest = this.stopMicAudioTest;
    window.unmuteStreamAfterTest = this.unmuteStreamAfterTest;
  };

  microphoneTest = () => {
    window.micropTest(1);
    var visualizer = document.getElementById("visualizer");
    var paths = document.getElementsByTagName("path");
    var audioTest;
    window.microphoneAudioT = audioTest;
    this.recordingfile = "testRecording_" + new Date().getTime() + ".aac";
    this.recPath = "./";
    this.startRec = this.mainAgora.startAudioRecording(this.recPath + this.recordingfile, 32000, 2);
    if (this.startRec == 0) {
      this.muteStreamForTest();
      setTimeout(() => {
        this.mainAgora.stopAudioRecording();
        setTimeout(() => {
          window.microphoneAudioT = document.createElement("audio");
          window.microphoneAudioT.src = "../../../" + this.recordingfile;
          if (this.stopMicTesting == false) {
            window.microphoneAudioT.onloadedmetadata = function () {
              window.micropTest(2);
              window.microphoneAudioT.play();
              visualizer.setAttribute("display", "block");
              var audioContent = new AudioContext();
              var audioStream = audioContent.createMediaElementSource(window.microphoneAudioT);

              audioStream.connect(audioContent.destination);
              var analyser = audioContent.createAnalyser();
              audioStream.connect(analyser);
              analyser.fftSize = 1024;

              var frequencyArray = new Uint8Array(analyser.frequencyBinCount);
              visualizer.setAttribute("viewBox", "0 0 250 90");

              var path;
              for (var i = 0; i < 10; i++) {
                path = document.createElementNS("http://www.w3.org/2000/svg", "path");
                path.setAttribute("stroke-width", "10");
                path.setAttribute("stroke", "white");
                path.setAttribute("stroke-linecap", "round");
                path.setAttribute("stroke-linejoin", "round");
                visualizer.appendChild(path);
              }
              var doDraw = function () {
                requestAnimationFrame(doDraw);
                analyser.getByteFrequencyData(frequencyArray);
                var adjustedLength;
                for (var i = 1; i < 10; i++) {
                  adjustedLength = Math.floor(
                    (Math.floor(frequencyArray[i * 20]) - (Math.floor(frequencyArray[i * 20]) % 5)) / 5
                  );
                  if (adjustedLength == 0) {
                    adjustedLength = 1;
                  }
                  paths[i].setAttribute(
                    "d",
                    "M " + i * 25 + ",45 l 0,-" + adjustedLength + " l 0," + adjustedLength * 2
                  );
                }
              };
              doDraw();
            };
          }
          setTimeout(() => {
            visualizer.setAttribute("display", "none");
            window.microphoneAudioT.pause();
            window.micropTest(3);

            if (window["fsFile"]) {
              try {
                window["fsFile"].unlinkSync(this.recPath + this.recordingfile);
              } catch (err) {}
            }
            this.unmuteStreamAfterTest();
          }, 5000);
        }, 1000);
      }, 5000);
    }
  };

  visualizerHide = () => {
    var visualizer = document.getElementById("visualizer");
    visualizer.setAttribute("display", "none");
  };

  stopMicAudioTest = () => {
    if (window.microphoneAudioT) {
      window.microphoneAudioT.pause();
    }
  };

  muteStreamForTest = () => {
    this.mainAgora.muteLocalAudioStream(true);
    this.mainAgora.muteAllRemoteAudioStreams(true);
  };

  unmuteStreamAfterTest = () => {
    this.mainAgora.muteLocalAudioStream(false);
    this.mainAgora.muteAllRemoteAudioStreams(false);
  };

  speakerTest = () => {
    this.muteStreamForTest();
    /*var mainSpeakerTestStream;
    mainSpeakerTestStream = this.mainAgora.createStream({ streamID: new Date().getTime(), audio: true, video: false });
    var path = "assets/assets/dashboard/Stream/test_speaker.mp3";
    mainSpeakerTestStream.startAudioMixing({ filePath: path, playTime: 0 });*/
    this.audio = new Audio("assets/assets/dashboard/Stream/test_speaker.mp3");
    this.audio.play();
    window.speakTest(1);
    setTimeout(() => {
      this.audio.pause();
      window.speakTest(0);
      this.unmuteStreamAfterTest();
    }, 5000);
  };

  stopSpeakerTestOneToOne = () => {
    if (this.audio) {
      this.audio.pause();
    }
  };

  listenEvents = () => {
    this.mainAgora.on("userOffline", function (uid, reason) {
      console.log("user reason", reason);
      if (reason == 0) {
        console.log("user left call", uid);
        document.querySelector("#agora_other_stream").innerHTML = "";
      }
      if (reason == 1) {
        console.log("user lost connection", uid);
        window.flutter_hostConnectionState(2);
      }
    });

    this.mainAgora.on("connectionStateChanged", function (state) {
      console.log("reconnected", state);
      if (state == 3) {
        window.flutter_connectionState(0);
      } else if (state == 4) {
        window.flutter_connectionState(1);
      }
    });
  };
}

export default agoraElectron;
